import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import HeadingLayout from '@/components/elements/Heading';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface BenefitsProps {
  blok: any;
  content: any;
}

function TextItem({ heading, content }) {
  return (
    <div className="ml-6 space-y-2">
      <HeadingLayout
        element="h2"
        size="2xs"
        weight="medium"
        className="relative"
      >
        <span className="absolute top-2 -ml-3 hidden rounded-full bg-theme-primary md:-ml-6 md:block md:h-2.5 md:w-2.5"></span>
        {heading}
      </HeadingLayout>
      <Prose size="sm" content={content} />
    </div>
  );
}

const Benefits: FC<BenefitsProps> = ({ blok }) => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.35,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 75,
        mass: 0.75,
        duration: 0.35,
      },
    },
  };

  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container size={'wider'} className="flex flex-col gap-12">
        <StandardText blok={blok} size={StandardTextSize.MD} />
        <motion.ul
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={container}
          className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16 lg:grid-cols-3 lg:gap-24"
        >
          {blok.benefits.map((b) => (
            <motion.li variants={item} key={b._uid}>
              <TextItem heading={b.heading} content={b.content} />
            </motion.li>
          ))}
        </motion.ul>
      </Container>
    </Section>
  );
};

export default Benefits;
